import { useSelector } from "react-redux";
import { selectActors } from "../../app/slices/TrainingSlice";
import { ActorState } from "../../models/ActorState";
import OutfitPickerField from "../outfit_picker/OutfitPickerField";

/** The take's outfit for this actor ("" keeps their own), chosen in the outfit picker. */
export default function ActorStateOutfitDropdown(props: {
  actorState: ActorState;
  onChange: (outfit: string) => void;
  disabled?: boolean;
}) {
  const { actorState, onChange, disabled } = props;
  const actors = useSelector(selectActors);
  const actor = actors.find((candidate) => candidate.id === actorState.actorId);

  return (
    <OutfitPickerField
      context="take"
      actor={actor}
      value={actorState.outfit ?? ""}
      onChange={onChange}
      disabled={disabled}
      className="w-full"
    />
  );
}
